<template>
    <div class="searbo">
        <div class="hotbs"><p class="wztit">应用中心</p></div>
        <div class="bmlibo">
            <div class="obo">
                <van-cell title="堵路移车" is-link link="/"></van-cell>
                <van-cell title="失物招领" is-link to="/lostFoundList"></van-cell>
                <van-cell title="身边警局" is-link to="/"></van-cell>
                <van-cell title="线索举报" is-link to="/clueReport"></van-cell>
                <van-cell title="身份证办理进度查询" is-link to="/idQuery"/>
                <van-cell title="居住证办理进度查询" is-link to="/resquery"></van-cell>
                <van-cell title="户口办理进度查询" is-link to="/"></van-cell>
                <van-cell title="出入境办理进度查询" is-link to="/"></van-cell>
                <van-cell title="重名查询" is-link link="/name"></van-cell>
                <van-cell title="港澳台居民居住证受理点查询" is-link link="/"></van-cell>
                <van-cell title="居住登记状态查询" is-link link="/"></van-cell>
                <van-cell title="出入境签注查询" is-link link="/"></van-cell>
                <van-cell title="出入境记录查询出入境证件查询" is-link link="/"></van-cell>
                <van-cell title="中国驻外使馆联系方式查询" is-link link="/"></van-cell>
                <van-cell title="EMS查询" is-link link="/ems"></van-cell>
                <van-cell title="驾驶证记分查询" is-link link="/"></van-cell>
                <van-cell title="机动车违法查询" is-link link="/"></van-cell>
                <van-cell title="公章刻制单位名录查询" is-link link="/"></van-cell>
                <van-cell title="开锁单位/人员名录查询" is-link link="/"></van-cell>
            </div>
        </div>
    </div>
</template>

<script>
    import {Cell, Button, Toast, CellGroup} from 'vant'

    export default {
        data() {
            return {}
        },
        created() {

        },
        methods: {},
        components: {
            [Cell.name]: Cell,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup
        }
    }
</script>

<style type="text/css" scoped>
    .searbo {
        width: 100%;
        height: 100%;
        float: left;
        position: relative;
        top: 0px;
        left: 0px;
    }

    .hotbs {
        width: 100%;
        height: 40px;
        float: left;
        background: #ffffff no-repeat 10px center;
        background-size: auto 20px;
        border-bottom: 1px solid #F2F2F2;
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 10;
    }

    .hotbs .wztit {
        height: 40px;
        float: left;
        line-height: 40px;
        margin-left: 40px;
        font-size: 18px;
        font-family: '微软雅黑';
    }

    .bmlibo {
        width: 100%;
        height: 100%;
        float: left;
        padding-top: 40px;
        box-sizing: border-box;
        overflow: hidden;
    }

    .obo {
        width: 100%;
        height: 100%;
        float: left;
        overflow-y: auto;
    }

</style>